import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { CheckIcon } from 'lucide-react';

import { cn } from '@/lib/utils';
import { focusRingClassNames } from './utils';

function Checkbox({
    className,
    ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
    return (
        <CheckboxPrimitive.Root
            data-slot="checkbox"
            className={cn(
                // Base styles
                'peer size-4 shrink-0 rounded-[4px] border shadow-xs outline-none transition-[transform,box-shadow] duration-150 ease-out',
                // Pressed (pointer / touch down)
                'active:scale-[0.92] motion-reduce:transition-none motion-reduce:active:scale-100',
                'disabled:active:scale-100',
                // Base unchecked state (when feature flag is OFF - uses default dark theme)
                'bg-input/30 border-input',
                // Base checked state (when feature flag is OFF - uses default dark theme)
                'data-[state=checked]:bg-primary data-[state=checked]:border-primary data-[state=checked]:text-primary-foreground',
                // Unchecked state - Light theme (when feature flag is ON)
                'light:bg-white light:border-primary',
                // Unchecked state - Dark theme (when feature flag is ON)
                'dark:bg-background dark:border-accent',
                // Checked state - Light theme (when feature flag is ON)
                'light:data-[state=checked]:bg-primary light:data-[state=checked]:border-primary light:data-[state=checked]:text-primary-foreground',
                // Checked state - Dark theme (when feature flag is ON)
                'dark:data-[state=checked]:bg-accent dark:data-[state=checked]:border-accent dark:data-[state=checked]:text-background',
                // Focus states
                focusRingClassNames,
                // Invalid states
                'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
                // Disabled state
                'disabled:cursor-not-allowed disabled:opacity-50',
                className,
            )}
            {...props}
        >
            <CheckboxPrimitive.Indicator
                data-slot="checkbox-indicator"
                className="flex items-center justify-center text-current transition-none"
            >
                <CheckIcon className="size-3.5" />
            </CheckboxPrimitive.Indicator>
        </CheckboxPrimitive.Root>
    );
}

export { Checkbox };
